import { useMemo } from "react";
import { Table, Typography } from "antd";
const { Text } = Typography;

const formatInr = (value) =>
    `₹ ${new Intl.NumberFormat("en-IN").format(value)}`;

const CreditLimitBreakup = ({ businessUser, dealCategoryId }) => {
    const dataSource = useMemo(
        () =>
            businessUser
                ?.filter((item) => {
                    if (!item) return false;
                    // Filter by dealCategoryId if provided and present on enterprise item
                    if (dealCategoryId && item.dealCategoryId && item.dealCategoryId !== dealCategoryId) {
                        return false;
                    }
                    const statusId = item.status_id || item.busEntStatusId;
                    const statusName = (item.status || item.statusName || "").toString().trim().toUpperCase();
                    if (statusId) {
                        if (statusId === "USM1000001" || statusId.toUpperCase() === "PENDING") {
                            return false;
                        }
                        if (statusId === "USM1000002" || statusId.toUpperCase() === "ACTIVE") {
                            return true;
                        }
                    }
                    if (statusName) {
                        if (statusName === "PENDING") return false;
                        if (statusName === "ACTIVE") return true;
                    }
                    return true;
                })
                ?.map((item, index) => ({
                    key: index + 1,
                    name: item.ent_name,
                    approved: item.approved_credit ?? 0,
                    utilized: item.used_credit ?? 0,
                    balance: item.balance ?? 0,
                })) ?? [],
        [businessUser, dealCategoryId]
    );

    const columns = useMemo(
        () => [
            {
                title: "Enterprise Name",
                dataIndex: "name",
                key: "name",
                width: 300,
                render: (text) => <Text>{text}</Text>,
            },
            {
                title: "Approved",
                dataIndex: "approved",
                key: "approved",
                width: 180,
                render: (value) => <Text>{formatInr(value)}</Text>,
            },
            {
                title: "Utilized",
                dataIndex: "utilized",
                key: "utilized",
                width: 180,
                render: (value) => <Text>{formatInr(value)}</Text>,
            },
            {
                title: "Balance",
                dataIndex: "balance",
                key: "balance",
                width: 180,
                render: (value) => <Text>{formatInr(value)}</Text>,
            },
        ],
        []
    );

    return (
        <div className="credit-limit-breakup-container">
            <Table
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                bordered={false}
                scroll={{ y: 230 }}
            />
        </div>
    );
};

export default CreditLimitBreakup;
